import { collection, onSnapshot, query, where } from 'firebase/firestore';

function ModeratorFactory(firebase) {
  const subscribeToAllSessionContributors = ({ sessionId, snapshot }) => {
    const ref = collection(firebase.fsdb, 'users');
    const q = query(
      ref,
      where('sessionsUserHasAccessTo', 'array-contains', sessionId)
    );
    return onSnapshot(q, snapshot);
  };

  return {
    subscribeToAllSessionContributors
  };
}

export default ModeratorFactory;
